import { useCallback, useState } from "react";

export function useRowLoading() {
  const [load, setLoad] = useState<string[]>([]);

  const addLoad = useCallback((id: string) => {
    setLoad((prev) => (prev.includes(id) ? prev : [...prev, id]));
  }, []);

  const removeLoad = useCallback((id: string) => {
    setLoad((prev) => prev.filter((item) => item !== id));
  }, []);

  const isLoading = useCallback((id: string) => load.includes(id), [load]);

  return { load, addLoad, removeLoad, isLoading };
}
